import React, { FC } from "react";
import { ToastContainer as ReactToastifyToastContainer } from "react-toastify";

import "./styles.scss";

export const ToastContainer: FC = () => {
  return <ReactToastifyToastContainer newestOnTop />;
};
